import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { InputMask } from '../../../../../CommonComponents/OPL/Input/InputMask';
import { StepCard } from '../../StepCard/StepCard';

export const PARTNER_FIRST_NAME = 'partnerFirstName';
export const PARTNER_LAST_NAME = 'partnerLastName';
export const PARTNER_BIRTH_DATE = 'partnerBirthDate';

export interface PartnerDataFormField {
  [PARTNER_FIRST_NAME]?: string;
  [PARTNER_LAST_NAME]?: string;
  [PARTNER_BIRTH_DATE]?: string;
}

export const PartnerData = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<PartnerDataFormField>();

  return (
    <>
      <StepCard>
        <Text color="neutral.700" fontSize="h3" fontWeight={500}>
          What is your partner’s name?
        </Text>

        <Box display="flex" mt="32">
          <Input
            {...register(PARTNER_FIRST_NAME)}
            label="First Name"
            placeholder="First Name"
            mr="16"
            formVariant={errors[PARTNER_FIRST_NAME] ? 'error' : undefined}
            helperText={errors[PARTNER_FIRST_NAME]?.message}
          />

          <Input
            {...register(PARTNER_LAST_NAME)}
            label="Last Name"
            placeholder="Last Name"
            formVariant={errors[PARTNER_LAST_NAME] ? 'error' : undefined}
            helperText={errors[PARTNER_LAST_NAME]?.message}
          />
        </Box>
      </StepCard>

      <StepCard mt="32">
        <Text color="neutral.700" fontSize="h3" fontWeight={500}>
          When is your partner’s birthday?
        </Text>
        <Text color="neutral.500" mt="8">
          Your age and time until retirement are key factors in assessing your risk tolerance
        </Text>

        <Box display="flex" mt="32">
          <InputMask
            aria-label="Your partner’s birth date"
            autoComplete="bday"
            formVariant={errors[PARTNER_BIRTH_DATE] ? 'error' : undefined}
            helperText={errors[PARTNER_BIRTH_DATE]?.message}
            label="Your partner’s birth date"
            leftIcon="far fa-calendar-alt"
            mask="99/99/9999"
            placeholder="MM/DD/YYYY"
            {...register(PARTNER_BIRTH_DATE)}
            type="text"
          />
        </Box>
      </StepCard>
    </>
  );
};
